export const notificationsArr = [
  { id: 1, val: '10 mins ago', },
  { id: 2, val: '1 months ago', },
  { id: 3, val: '2 days ago', },
  { id: 4, val: '2 months ago', },
  { id: 5, val: '3 months ago', },
];
